import React, { useState } from 'react'
import { Spin } from 'antd'
import Input from '../../../baseComponent/input'
import request from '../../../utils/request'
import ModalConfirm from '../../modal/modalConfirm'
import TagLists from '../../imageDetail/tagSelection'
import Textarea from '../../../baseComponent/textarea'
import { StyleSelect, MnInputNum } from '../../imageDetail/styleSelect'
import { AttrFactory } from '../../imageDetail/attrFactory'
import { GENDER_OPTIONS } from '../../enum'
import Icon from '../../icon'
import './index.less'

const TYPE = {
  TEXT: 1,
  TAG: 2,
  NUM: 3,
  LINK: 4,
  BOOL: 5,
  SINGLE: 6,
  MULTIPLE: 7,
  DATE: 8,
  MEMBER: 9,
}

export default ({ formParams, onFormChange, children, listWidth }) => {
  const [nextStatus, setNextStatus] = useState(false)
  return (
    <div
      className="add-inspiration-info-column-wrap"
      style={{ width: listWidth * 2, transform: `translateX(${nextStatus ? -listWidth : 0}px)` }}
    >
      <div className="add-inspiration-info-column-1" style={{ width: listWidth }}>
        {children}
        <div className="section-option-item" style={{ marginTop: '16px' }}>
          <span className="label">款式名称</span>
          <Input
            wrapClassName="mn-add-inspiration-style-title"
            value={formParams.styleTitle}
            maxLength={50}
            onChange={(e) => onFormChange({ styleTitle: e.target.value })}
            suffix={<div className="mn-add-inspiration-style-title-suffix">{formParams?.styleTitle?.length}/50</div>}
          />
        </div>
        <div
          className="add-inspiration-info-more-btn"
          onClick={() => {
            setNextStatus(true)
          }}
        >
          点击填写更多
          <Icon type="m-Vxing_you" className="add-inspiration-info-next-icon" />
        </div>
      </div>
      <div className="add-inspiration-info-column-2" style={{ width: listWidth }}>
        <div className="add-inspiration-info-column-2-goBack" onClick={() => setNextStatus(false)}>
          <Icon type="m-Vxing_zuo" className="add-inspiration-info-next-icon" /> 返回
        </div>
        <div
          style={{
            height: '518px',
            overflow: 'auto',
            padding: ' 0 8px',
            margin: '0 -8px',
          }}
        >
          <Tag wrapStyle={{ marginTop: '8px' }} value={formParams?.tags} onChange={(val) => onFormChange({ tags: val })} />
          <MnInputNum
            placeholder="点击输入参考价格"
            style={{ marginTop: '8px' }}
            className="add-inspiration-info-column-MnInputNum"
            value={formParams.price}
            onChange={(val) => onFormChange({ price: val })}
          />
          <Description
            wrapStyle={{ height: 76, marginTop: '8px' }}
            value={formParams.description}
            onChange={(val) => onFormChange({ description: val })}
          />
          <AttrList formParams={formParams} onFormChange={onFormChange} />
        </div>
      </div>
    </div>
  )
}

const convertData = (data) => {
  if (data?.length > 0) {
    const visibleData = data.filter((item) => item.isVisible)
    return visibleData.map((item) => {
      return {
        propertyId: item.propertyId,
        propertyName: item.propertyName,
        propertyType: item.propertyType,
        values: [],
      }
    })
  }
  return []
}

const mergeData = (generalList, pointsList) => {
  for (let i = 0; i < generalList.length; i++) {
    for (let j = 0; j < pointsList.length; j++) {
      if (generalList[i].propertyId == pointsList[j].propertyId) {
        generalList[i] = pointsList[j]
      }
    }
  }
  return generalList
}
const isFindItem = (data, val) => {
  let is = false
  if (data?.length === 0) {
    return false
  }
  data.forEach((item) => {
    if (val.includes(item.value)) {
      is = true
    }
    if (item?.childItems?.length) {
      isFindItem(item?.childItems, val)
    }
  })
  return is
}

const dealAttr = (attrVal) => {
  if (attrVal instanceof Array) {
    return [...attrVal]
  }
  if (attrVal instanceof Set) {
    return Array.from(attrVal)
  }
  if (attrVal == null || attrVal == undefined || attrVal == 'null') {
    return []
  }
  return [attrVal]
}

const AttrList = ({ formParams, onFormChange }) => {
  const [industryAttr, setIndustryAttr] = useState([])
  const [switchGender, setSwitchGender] = useState(false)
  const [loading, setLoading] = useState(false)

  const fetchAttrData = async (_gender) => {
    if (!_gender) return
    setLoading(true)
    const res = await request.get(`/zhikuan/mn/property/list?targetType=1&gender=${_gender}`)
    getPropertyValueParamList(res)
    setIndustryAttr(res)
    setLoading(false)
  }

  const onGender = (val) => {
    if (formParams.gender && val != formParams.gender) {
      ModalConfirm.show({
        title: '确认更换行业？',
        content: '更换行业后将清空现有款式属性',
        onOk: () => {
          onFormChange({ gender: val })
          setSwitchGender(true)
          fetchAttrData(val)
        },
      })
    } else {
      onFormChange({ gender: val })
      fetchAttrData(val)
    }
  }

  const getPropertyValueParamList = (_industryAttr) => {
    let newData = []
    if (!switchGender && _industryAttr.length > 0) {
      const convertIndustry = convertData(_industryAttr)
      if (formParams.propertyValueParamList?.length > 0) {
        const mergeParamList = mergeData(convertIndustry, formParams.propertyValueParamList)
        newData = mergeParamList
      } else {
        newData = convertIndustry
      }
    }
    if (switchGender) {
      const convertIndustry = convertData(_industryAttr)
      if (formParams.propertyValueParamList?.length > 0) {
        const mergeParamList = mergeData(convertIndustry, formParams.propertyValueParamList)
        newData = mergeParamList
      } else {
        newData = convertIndustry
      }
    }

    if (newData) {
      // 单独处理 级联 删除了设置的选项则需要过滤掉 values
      const filterPropertyValueList = newData?.map((item) => {
        if (_industryAttr.length) {
          if (_industryAttr.find((arr) => arr.propertyId === item.id) !== -1) {
            const findItem = _industryAttr.find((arr) => arr.propertyId === item.propertyId)
            if (findItem?.propertyType === TYPE.MULTIPLE) {
              item.values = item.values.filter((it) => {
                return isFindItem(findItem?.multiStruct?.rootItems, it.split('^'))
              })
            }
          }
        }
        return item
      })
      onFormChange({ propertyValueParamList: [...filterPropertyValueList] })
    } else {
      onFormChange({ propertyValueParamList: [] })
    }
  }

  const onChangePropertyValue = (id, attrVal, type, name) => {
    if (formParams.propertyValueParamList.findIndex((m) => m.propertyId === id) >= 0) {
      const newPropertyValueParamList = formParams.propertyValueParamList.filter((item) => item.propertyId != id)
      newPropertyValueParamList.push({ propertyId: id, values: dealAttr(attrVal), propertyType: type, propertyName: name })
      onFormChange({ propertyValueParamList: [...newPropertyValueParamList] })
    } else {
      formParams.propertyValueParamList.push({
        propertyId: id,
        values: dealAttr(attrVal),
        propertyType: type,
        propertyName: name,
      })
      onFormChange({ propertyValueParamList: [...formParams.newPropertyValueParamList] })
    }
  }

  return (
    <div style={{ marginTop: '16px' }}>
      <div className="section-option-item" id="gender">
        <span className="label">所属行业</span>
        <StyleSelect
          style={{ height: '32px', flex: '1' }}
          className="add-inspiration-info-column-select"
          placeholder="点击选择"
          value={formParams.gender}
          options={GENDER_OPTIONS}
          onChange={(val) => onGender(val)}
        />
      </div>
      <Spin spinning={loading}>
        <div>
          {!formParams.gender ? (
            <div className="prompt-meg">
              <Icon type="m-zhuyi_tianchong" />
              <span>请先选择行业后，填写相关款式属性</span>
            </div>
          ) : (
            <AttrFactory
              onChange={(id, value, type, name) => onChangePropertyValue(id, value, type, name)}
              className="add-inspiration-info-column-attr"
              industryAtrr={industryAttr}
              value={[...formParams.propertyValueParamList]}
            />
          )}
        </div>
      </Spin>
    </div>
  )
}

const Tag = ({ value, onChange, wrapStyle }) => {
  return (
    <TagLists
      type="fetchInterface"
      value={value}
      onChange={(val) => onChange(val)}
      suffix={20}
      style={{ width: '100%' }}
      wrapStyle={wrapStyle}
      closeFold
      className="ins-add-inspiration-info-tag-lists"
    />
  )
}

const Description = ({ value, onChange, wrapStyle }) => {
  return (
    <Textarea
      wrapClassName="mn-add-inspiration-create-comment"
      placeholder="输入内容，来让自己或其他成员更好的了解款式的面料，辅料、工艺、风格、颜色及卖点"
      minHeight={null}
      maxLength={400}
      wrapStyle={wrapStyle}
      value={value}
      onInput={(e) => onChange(e.target.value)}
    />
  )
}
